import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faFacebook, faTwitter, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { Social } from './../../elements/SharedElements';

const Socials = () => (
    <Social>
        <div className="container">
            <h2>Get In <span className="effect">Touch</span></h2>
            <div className="socials">
                <div className="social">
                    <FontAwesomeIcon icon={faWhatsapp} />
                    <h4>WhatsApp</h4>
                    <a href="tel:0639351585" target="_blank" rel="noreferrer">063 935 1585</a>
                </div>
                <div className="social">
                    <FontAwesomeIcon icon={faFacebook} />
                    <h4>Facebook</h4>
                    <a href="https://www.facebook.com/zapowerhouse" target="_blank" rel="noreferrer">@ZaPowerHouse</a>
                </div>
                <div className="social">
                    <FontAwesomeIcon icon={faTwitter} />
                    <h4>Twitter</h4>
                    <a href="https://twitter.com/ZaPowerHouse" target="_blank" rel="noreferrer">@ZaPowerHouse</a>
                </div>
                <div className="social">
                    <FontAwesomeIcon icon={faInstagram} />
                    <h4>Instagram</h4>
                    <a href="https://www.instagram.com/zapowerhouse/" target="_blank" rel="noreferrer">@ZaPowerHouse</a>
                </div>
                <div className="social">
                    <FontAwesomeIcon icon={faEnvelope} />
                    <h4>Email</h4>
                    <a href="mailto:info@zapowerhouse.co.za" target="_blank" rel="noreferrer">info@zapowerhouse.co.za</a>
                </div>
            </div>
        </div>
    </Social>
)

export default Socials;